// Interfaces
import {CookieOptions} from "@/shared/scripts/helpers/cookie/Cookie.interfaces";

/**
 * [getCookie Return the content of a given cookie]
 * @param  {String} name [The name of the cookie]
 * @param  {Boolean} json [If true, it will return the cookie has a JSON.parse]
 */
export function getCookie(name: string, json?: boolean): string | Record<string, unknown> | void {

    // Retrieve the cookie based on the name
    const result = document.cookie.match(new RegExp(name + "=([^;]+)"));

    if (result) {
        // Get the "content" of the cookie
        let cookie = result[1];

        // If JSON, try to convert the cookie content to a javascript object
        if (json) {
            try {
                cookie = JSON.parse(cookie);
            } catch (e) {
                return e as Record<string, unknown>;
            }
        }

        return cookie;
    }

    return;
}

/**
 * [setCookie Write a cookie]
 * @param {String} name       [The name of the cookie]
 * @param {string} value      [The content of the cookie]
 * @param {Object} attributes [A list of optional parameters (path, expires)]
 */
export function setCookie(name: string, value: string | Record<string, unknown> | Array<unknown>, attributes: CookieOptions): void {

    // Check if value is a possible Array or Object, if so pass it has a JSON string
    try {
        const result = JSON.stringify(value);
        if (/^[{[]/.test(result)) {
            value = result;
        }
    } catch (e) {
        // Do nothing
    }

    // Handle the expirations date parameters
    if (typeof attributes.expires === "number") {
        const expireDate = +new Date() * 1 + attributes.expires * 864e+5;
        attributes.expires = new Date(expireDate);
    }
    // We're using "expires" because "max-age" is not supported by IE
    if (typeof attributes.expires === "object") {
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
    }

    // Process all attributes to a formated string
    let stringifiedAttributes = "" as string;
    for (const attributeName in attributes) {
        if (!attributes[attributeName]) {
            continue;
        }
        stringifiedAttributes += "; " + attributeName;
        if (attributes[attributeName] === true) {
            continue;
        }

        // Considers RFC 6265 section 5.2:
        // ...
        //  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += "=" + (attributes[attributeName] as string).split(";")[0];
    }

    // Construct and save the cookie
    const cookie = name + "=" + value + stringifiedAttributes as string;

    document.cookie = cookie;
}
